const state = {
  drawer: false,
  keyboardInfos: [
    {
      type: "subheader",
      text: "Deployment"
    },
    {
      title: "Mobile SDKs",
      icon: "screen_lock_portrait",
      iconClass: "",
      color: "green",
      subtitle: "iOS/Android"
    },
    {
      type: "subheader",
      text: "Features"
    },
    {
      title: "Autocorrect",
      icon: "spellcheck",
      iconClass: "",
      color: "green"
    },
    {
      title: "Autocomplete",
      icon: "forward",
      iconClass: "",
      color: "green"
    }
  ],
  interactInfos: [
    {
      type: "subheader",
      text: "Deployment"
    },
    {
      title: "Mobile SDKs",
      icon: "screen_lock_portrait",
      iconClass: "",
      color: "green",
      subtitle: "iOS/Android"
    },
    {
      title: "Cloud",
      icon: "cloud_done",
      iconClass: "",
      color: "green",
      subtitle: "API Access"
    },
    {
      title: "Local Server",
      icon: "storage",
      iconClass: "",
      color: "green",
      subtitle: "On premise"
    }
  ],
  pageElements: {
    text_age_verification: {
      color: "#43a047",
      img: require("@/assets/images/age_verification.png"),
      explanation:
        "Out text-based age verification model provides estimates of a user's age based on their input text."
    },
    video_age_verification:{
      color: "#d76a09",
      img: require("@/assets/images/age_verification.png"),
      explanation: "Our video age verification model estimates a user's age based on a short audio-video recording. We can also provide an estimate using only audio or video but using both provides better results"
    },
    multimodal_emotion: {
      color: "#f17e7e",
      img: require("@/assets/images/multimodal.png")
    }
  }
};

const getters = {
  drawer: state => {
    return state.drawer;
  },
  pageElements: state => {
    return state.pageElements;
  },
  interactInfos: state => {
    return state.interactInfos;
  },
  keyboardInfos: state => {
    return state.keyboardInfos;
  }
};

const mutations = {
  setDrawer: (state, payload) => {
    state.drawer = payload;
  }
};

const actions = {
  setDrawer: ({ commit }, payload) => {
    commit("setDrawer", payload);
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
